module.exports = __webpack_public_path__ + "3848279e1aaa521f3d241b7908734fb4.ttf";